module.exports = __webpack_public_path__ + "static/media/HomeHeroStudents.077e849b.jpg";